module.exports = __webpack_public_path__ + "static/media/create_reservation_select_stop_date.cac01fc0.jpg";